import { Dropdown } from "components/Dropdown";
import { formatTo2DigitString } from "features/shared/lib/formatters";
import { useMemo } from "react";

import { FLUSHING_SETTINGS_INPUT_WIDTH, TRANSIENT_INPUT_HEIGHT } from "../lib/transientForm";

const HOUR_OPTIONS = Array.from({ length: 24 }, (_, hour) => hour);

type ScenarioDayNightFlushingHoursCellProps = {
  onChange: (hours: number[]) => void;
  selectedHours: number[];
};

export const ScenarioDayNightFlushingHoursCell = ({
  onChange,
  selectedHours,
}: ScenarioDayNightFlushingHoursCellProps) => {
  const displayOptions = useMemo(() => HOUR_OPTIONS.map((hour) => `${formatTo2DigitString(hour)}:00`), []);

  return (
    // @ts-expect-error Dropdown is a JS component with incomplete prop typings.
    <Dropdown
      className={FLUSHING_SETTINGS_INPUT_WIDTH}
      displayOptions={displayOptions}
      height={TRANSIENT_INPUT_HEIGHT}
      label=" "
      options={HOUR_OPTIONS}
      setValues={(hours: Array<number | string>) => {
        onChange(
          hours
            .map((hour: number | string) => Number(hour))
            .filter((hour: number) => Number.isFinite(hour))
            .sort((first: number, second: number) => first - second)
        );
      }}
      values={selectedHours}
    />
  );
};
